import { useMutation } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";

export const useGdprExportRequest = () => {
  const requestGdprExport = useMutation({
    mutationFn: async ({ userId }) => {
      return makeApiRequest({
        endpoint: "/api/support/gdpr-export",
        method: "POST",
        body: { userId },
        json: true
      });
    }
  });

  return { requestGdprExport };
};
